import { inject, Injectable } from '@angular/core';
import { IUseCase } from '@core/base/use-case.interface';
import { DocumentTypeEnum } from '@core/enums/document/document-type.enum';
import { IPolicyDocumentResponseDto } from '@core/interfaces/api/policies/policy-document-response-dto.interface';
import { FtsAccessManagementApiService } from '@core/services/api/access-management.api.service';
import { Observable } from 'rxjs';

@Injectable()
export class GetPolicyUseCaseService
  implements IUseCase<DocumentTypeEnum, IPolicyDocumentResponseDto>
{
  private readonly ftsAccessManagementService = inject(FtsAccessManagementApiService);

  execute(params: DocumentTypeEnum): Observable<IPolicyDocumentResponseDto> {
    return this.ftsAccessManagementService.getPolicyDocument(params);
  }
}
